import { Flex, FloraTypography } from '@grupoboticario/flora-react'

import { infoFieldLabelStyle, infoFieldValueStyle, fieldRowStyle, INFO_FIELD_DEFAULT_MARGIN_LEFT } from './styles'

const InfoField = ({ label, value, marginLeft = INFO_FIELD_DEFAULT_MARGIN_LEFT }) => (
  <Flex css={{ ...fieldRowStyle, marginLeft }} align="center">
    <FloraTypography css={infoFieldLabelStyle} as="span" fontSize="bodyLargeStandard" fontWeight="bold">
      {label}
    </FloraTypography>
    <FloraTypography css={infoFieldValueStyle} as="span" fontSize="bodyLargeStandard">
      {value}
    </FloraTypography>
  </Flex>
)

export default InfoField
